import React, { useEffect, useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ApprovalNotification = ({
  isVisible,
  onClose,
  level = 'Level 1',
  vendorName,
  reason,
  remarks,
  autoHide = true,
  autoHideDelay = 5000
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsAnimating(true);

      if (autoHide) {
        const timer = setTimeout(() => {
          onClose();
        }, autoHideDelay);

        return () => clearTimeout(timer);
      }
    }
  }, [isVisible, autoHide, autoHideDelay, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className={`
        bg-white border shadow-lg rounded-lg p-4 max-w-md w-full
        transform transition-all duration-300 ease-in-out
        ${isAnimating ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}
      `}>
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            {level === 'Rejected' ? (
              <div className="w-8 h-8 bg-error/10 rounded-full flex items-center justify-center">
                <Icon name="XCircle" className="w-5 h-5 text-error" />
              </div>
            ) : level === 'Error' ? (
              <div className="w-8 h-8 bg-destructive/10 rounded-full flex items-center justify-center">
                <Icon name="AlertTriangle" className="w-5 h-5 text-destructive" />
              </div>
            ) : (
              <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name="CheckCircle" className="w-5 h-5 text-success" />
              </div>
            )}
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between">
              <h4 className="text-sm font-semibold text-gray-900">
                {level === 'Rejected' ? 'Vendor Rejected' : level === 'Error' ? 'Action Failed' : `${level} Approval Successful`}
              </h4>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <Icon name="X" className="w-4 h-4" />
              </button>
            </div>

            {level === 'Rejected' ? (
              <div className="mt-2 space-y-2 text-sm text-gray-700">
                <p>
                  Vendor <span className="font-medium">{vendorName}</span> has been rejected.
                </p>
                {reason && (
                  <p><span className="text-gray-500">Reason:</span> <span className="font-medium">{reason}</span></p>
                )}
                {remarks && (
                  <p><span className="text-gray-500">Remarks:</span> {remarks}</p>
                )}
              </div>
            ) : level === 'Error' ? (
              <div className="mt-2 space-y-2 text-sm text-gray-700">
                <p>Action failed for <span className="font-medium">{vendorName}</span>.</p>
                {remarks && <p className="text-destructive">{remarks}</p>}
              </div>
            ) : (
              <>
                <p className="text-sm text-gray-600 mt-1">
                  Vendor <span className="font-medium">{vendorName}</span> has been successfully approved at {level} level.
                </p>
                <div className="mt-3 flex items-center space-x-2">
                  <div className="flex items-center space-x-1 text-xs text-success">
                    <Icon name="Mail" className="w-3 h-3" />
                    <span>
                      {level === 'Level 1' ? (
                        'Vendor Acknowledgement sent to vendor'
                      ) : (
                        'Excel report sent to satishshrivastav@ambergroupindia.com'
                      )}
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalNotification;
